<template>
  <div>
    <div class="overlayy" v-show="mapping">
      <v-container
        style="height: 400px;display: flex;margin-top:150px;
    justify-content: center;"
      >
        <v-progress-linear
          style="width: 150px;position: fixed;"
          color="#fff"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-container>
    </div>
    <div id="tabelaclientes">
      <v-layout v-resize="onResize" style="display:flex;flex-flow: column;">
        <div style="width: 100%">
          <v-text-field v-model="search" append-icon="search" label="Pesquisar" style="width: 100%"></v-text-field>
        </div>
        <div
          v-show="totalRegistros"
          :style="!isMobile ? 'display: flex;justify-content: space-between;align-items: center;' : 'display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap-reverse;'"
        >
          <div style="display: flex;">
            <div>
              <v-btn
                @click="openSelect = !openSelect"
                class="mx-2"
                fab
                dark
                small
                color="#2A5377"
                style="margin-left: 125px;"
              >
                <font-awesome-icon icon="check-circle" />
              </v-btn>
              <md-tooltip
                v-if="!isMobile"
                style="z-index: 200;"
                md-direction="bottom"
              >Selecionar Clientes</md-tooltip>
            </div>

            <!-- <v-btn
              style="border-radius: 20px"
              v-if="selected.length != 0 && openSelect"
              color="#2A5377"
              class="ma-2 white--text"
              @click="liberarArquivos(selected)"
            >
              <span>Liberar Arquivos</span>
              <font-awesome-icon style="margin-left:5px" icon="check-circle" />
              <md-tooltip v-if="!isMobile" style="z-index: 200;" md-direction="top">
                Liberar arquivos para {{selected.length}}
                <br />clientes selecionados
              </md-tooltip>
            </v-btn>-->
            <v-dialog
              v-if="selected.length != 0 && openSelect"
              v-model="dialog"
              width="800"
              height="800"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  style="border-radius: 20px"
                  color="#2A5377"
                  class="ma-2 white--text"
                  @click="liberarArquivos(selected)"
                  v-on="on"
                >
                  <span>Liberar Arquivos</span>
                  <font-awesome-icon style="margin-left:5px" icon="check-circle" />
                  <md-tooltip v-if="!isMobile" style="z-index: 200;" md-direction="top">
                    Liberar arquivos para {{selected.length}}
                    <br />clientes selecionados
                  </md-tooltip>
                </v-btn>
              </template>

              <app-component-clientes-liberar-arquivo
                :clientes="selected"
                :closeDialog="closeDialog"
              />
            </v-dialog>

            <div>
              <v-btn
                @click="findData(false);msg = 'Atualizando...';ocultarBloqueados = false"
                class="mx-2"
                fab
                dark
                small
                color="#2A5377"
                style="margin-left: 125px;"
              >
                <font-awesome-icon icon="sync" />
              </v-btn>
              <md-tooltip v-if="!isMobile" style="z-index: 200;" md-direction="bottom">Atualizar</md-tooltip>
            </div>
            <div class="controlstop" v-if="isMobile" style="    right: 16px;position: absolute;">
              <button
                @click="paginate('-')"
                type="button"
                class="v-btn v-btn--flat v-btn--icon theme--light"
                aria-label="Previous page"
              >
                <div class="v-btn__content">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_left</i>
                </div>
              </button>
              <button
                @click="paginate('+')"
                type="button"
                class="v-btn v-btn--flat v-btn--icon theme--light"
                aria-label="Next page"
              >
                <div class="v-btn__content">
                  <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_right</i>
                </div>
              </button>
            </div>
          </div>
          <div style="display: flex; align-items: center;">
            <v-sheet style="margin-right: 25px;">
              <v-switch
                @change="body.filter = $event; findData({filter: $event})"
                v-model="exibirInativos"
                inset
                color="#2A5377"
                :label="`Exibir clientes inativos`"
              ></v-switch>
            </v-sheet>
            <v-sheet style="margin-right: 25px;">
              <v-switch
                @change="toogleBloqueados"
                inset
                v-model="ocultarBloqueados"
                color="#2A5377"
                :label="`Ocultar clientes bloqueados`"
              ></v-switch>
            </v-sheet>
            <span>
              <b
                style="margin-right: 5px;font-weight: 700"
              >{{refreshed ? $refs.clientesTable.itemsLength : '?'}}</b>
              Clientes encontrados
            </span>
            <div class="text-xs-center">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    dark
                    v-on="on"
                  >
                    Copiar Dados
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile :key="0" @click="() => {
                    copyExcel();                    
                    msg = 'Copiado com sucesso.';
                  }" >
                    <v-list-tile-title>Excel</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile :key="1" @click="() => {
                    copyJSON();                    
                    msg = 'Copiado com sucesso.';
                  }">
                    <v-list-tile-title>JSON</v-list-tile-title>
                  </v-list-tile>                  
                </v-list>
              </v-menu>
            </div>            
          </div>          
        </div>
        <v-container
          v-if="loadinData"
          style="height: 400px;display: flex;margin-top:150px;
    justify-content: center;"
        >
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="subtitle-1 text-center" cols="12">Baixando dados..</v-col>
            <v-col cols="6">
              <v-progress-linear color="#88C658" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <div v-else>
          <div class="controlstop" v-if="!isMobile">
            <button
              @click="paginate('-')"
              type="button"
              class="v-btn v-btn--flat v-btn--icon theme--light"
              aria-label="Previous page"
            >
              <div class="v-btn__content">
                <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_left</i>
              </div>
            </button>
            <button
              @click="paginate('+')"
              type="button"
              class="v-btn v-btn--flat v-btn--icon theme--light"
              aria-label="Next page"
            >
              <div class="v-btn__content">
                <i aria-hidden="true" class="v-icon material-icons theme--light">chevron_right</i>
              </div>
            </button>
          </div>
          <v-data-table
            ref="clientesTable"
            :show-select="true"
            v-model="selected"
            select-all
            :single-select="false"
            :headers="headers"
            :items="clientesArr"
            :hide-headers="isMobile"
            :pagination.sync="pagination"
            @update:pagination="updatePagination"
            :class="{mobile: isMobile}"
            :search="search"
            item-key="CLICODIGO"
            no-results-text="Nada foi encontrado."
            no-data-text="Nada foi encontrado."
            rows-per-page-text="Items por página"
            style="width: 100%!important;"
          >
            <template v-slot:headers="props">
              <tr style="border-left:  15px solid #fff">
                <th v-if="openSelect">
                  <v-checkbox
                    primary
                    hide-details
                    @click.native="toggleAll"
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                  ></v-checkbox>
                  <md-tooltip style="z-index: 200;" md-direction="top">Selecionar Todos</md-tooltip>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :width="header.width"
                  :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr
                v-if="!isMobile"
                :active="props.selected"
                :style="{'border-left': ' 15px solid '+calcDiffDates(props.item.MAXLOGDATAHORA),'cursor':'pointer', 'background': (props.item.CLASSCLICODIGO > 2) ? '#ef9a9a' :'transparent'  }"
              >
                <td v-if="openSelect">
                  <v-checkbox
                    :disabled="props.item.BLOQUEADO"
                    primary
                    @change="addItemtoSelect(props.item)"
                    hide-details
                    :input-value="props.selected"
                  ></v-checkbox>
                </td>
                <td
                  class="text-xs-left"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.CLICODIGO || "---" }}</td>
                <td
                  class="text-xs-left"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.CLINOME || "---" }}</td>
                <td
                  class="text-xs-left"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.CLINOMEUSUAL || "---" }}</td>
                <td
                  class="text-xs-left"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.CLICNPJ || "---" }}</td>
                <td
                  class="text-xs-left"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.CLIIE || "---" }}</td>
               <!-- <td
                  class="text-xs-left"
                  style="min-width: 150px!important;"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.CLITELEFONEPRINCIPAL || "-" }}</td>
                <td class="text-xs-left" style="cursor:default;">
                  <md-icon
                    v-if="props.item.ENDCOMLPETE"
                    @click.native="openMaps(props.item)"
                    style="color: #2A5377;cursor:pointer;"
                  >location_on</md-icon>
                  <md-icon v-else style="color: rgba(153, 167, 181, 0.6);">location_off</md-icon>
                  <md-tooltip style="z-index: 200;" md-direction="left">Exibir no mapa</md-tooltip>
                  {{ props.item.ENDCOMLPETE || "-" }}
                </td>
                <td class="text-xs-left" @click="props.expanded = !props.expanded">
                  <b>{{props.item.CLIEMSVERSAO}}</b>
                </td>-->
                <td
                  class="text-xs-left"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.ATIVDESCRICAO || "---" }}</td>                
                <td
                  class="text-xs-left"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.CLIPERSONA || "---" }}</td>                
                <td
                  class="text-xs-left"
                  @click="props.expanded = !props.expanded"
                >{{ props.item.USUNOME || "---" }}</td>                
                <!--<td class="text-xs-right" @click="props.expanded = !props.expanded">
                  <b>{{props.item.SISCODIGOS}}</b>
                </td>-->
              </tr>
              <tr v-else>
                <td
                  :active="props.selected"
                  :style="{'padding':'0px','border-left': ' 15px solid '+calcDiffDates(props.item.MAXLOGDATAHORA),'cursor':'pointer', 'background': (props.item.CLASSCLICODIGO > 2) ? '#ef9a9a' :'transparent', 'margin-bottom': '35px'  }"
                >
                  <ul class="flex-content">
                    <li v-if="openSelect" class="flex-item" data-label="Selecionar:">
                      <v-checkbox
                        primary
                        @change="addItemtoSelect(props.item)"
                        hide-details
                        :input-value="props.selected"
                      ></v-checkbox>
                    </li>
                    <li class="flex-item" data-label="Código:">{{ props.item.CLICODIGO }}</li>
                    <li class="flex-item" data-label="Nome:">{{ props.item.CLINOME }}</li>
                    <li class="flex-item" data-label="Nome Usual:">{{ props.item.CLINOMEUSUAL }}</li>
                    <li class="flex-item" data-label="CNPJ:">{{ props.item.CLICNPJ }}</li>
                    <li class="flex-item" data-label="IE:">{{ props.item.CLIIE }}</li>
                    <!--<li
                      class="flex-item"
                      data-label="Telefone:"
                    >{{ props.item.CLITELEFONEPRINCIPAL }}</li>
                    <li class="flex-item" data-label="Versão EMS:">{{ props.item.CLIEMSVERSAO }}</li>
                    <li class="flex-item" data-label="Endereço:" style="word-wrap:break-word;">
                      <md-icon
                        v-if="props.item.ENDCOMLPETE"
                        @click.native="openMaps(props.item)"
                        style="color: #2A5377;cursor:pointer;"
                      >location_on</md-icon>
                      <md-icon v-else style="color: rgba(153, 167, 181, 0.6);">location_off</md-icon>
                      {{ props.item.ENDCOMLPETE }}
                    </li>-->
                    <li class="flex-item" data-label="Atividade:">{{ props.item.ATIVDESCRICAO }}</li>
                    <li class="flex-item" data-label="Persona:">{{ props.item.CLIPERSONA }}</li>
                    <li class="flex-item" data-label="Analista:">{{ props.item.USUNOME }}</li>
                    <!--<li class="flex-item" data-label="Sistemas:">{{ props.item.SISCODIGOS }}</li>-->
                  </ul>
                </td>
              </tr>
            </template>

            <template slot="no-data">
              <v-alert
                :value="true"
                color="error"
                icon="warning"
                style="color: #000!important"
              >Nada foi encontrado.</v-alert>
            </template>
            <template v-slot:expand="props" v-if="!isMobile">
              <DetalhesClientes :cliente="props.item" />
            </template>
            <template
              slot="pageText"
              slot-scope="item"
            >Exibindo {{item.pageStart}} - {{item.pageStop}}, Total {{item.itemsLength}}</template>
          </v-data-table>
        </div>
      </v-layout>

      <md-snackbar :md-active.sync="empSaved">Sucesso!</md-snackbar>
      <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
      <md-snackbar :md-active.sync="errorSaved">Erro interno do servidor</md-snackbar>
    </div>
    <Map
      style="z-index: 110"
      v-if="activemap"
      :endereco="endereco"
      :coords="coords"
      @closed="mapclosed"
    />
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000">
      {{ mensagem }}
      <v-btn dark flat @click="snackbar = false">
        <span class="caption app-text-initial">Fechar</span>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import DetalhesClientes from "./detalhesClientes";
import * as ClientesService from "../../providers/clientes.service";
import Map from "./map";
import * as Geocoding from "../../providers/geocoding.service";
import { gmapApi } from "vue2-google-maps";
import moment from "moment";
import { debuglog } from "util";
import liberarVersao from "./liberarVersao";

import LiberarArquivos from "./LiberarArquivos/LiberarArquivos.vue";

export default {
  name: "tabela-clientes",
  components: {
    Map,
    liberarVersao,
    DetalhesClientes,
    "app-component-clientes-liberar-arquivo": LiberarArquivos
  },
  computed: {
    google: gmapApi
  },
  watch: {
    versoes: function(val) {
      this.findData({}, true);
    },
    versoesEMS() {
      this.findData({}, true);
    },
    atividades: function(val) {
      this.findData({}, true);
    },
    personas: function(val) {
      this.findData({}, true);
    },
    analistas: function(val) {
      this.findData({}, true);
    },
    arquivos: function(val) {
      this.findData({}, true);
    },
    selected() {}
  },
  props: {
    recIcon: {
      type: String,
      path: require("@/assets/img/rec-marker.svg"),
      default: require("@/assets/img/rec-marker.svg")
    },
    versoes: {
      type: Array()
    },
    versoesEMS: {
      type: Array()
    },
    aplicativo: {
      type: String
    },
    atividades: {
      type: Array()
    },
    personas: {
      type: Array()
    },
    analistas: {
      type: Array()
    }    ,
    arquivos: {
      type: Array()
    }    
  },

  data() {
    return {
      dialog: false,
      situacoes: [
        {
          value: 0,
          text: "Pendentes"
        },
        {
          value: 1,
          text: "Liberados"
        },
        {
          value: 2,
          text: "Bloqueados"
        }
      ],
      exibirInativos: false,
      LoginDialogTrigger: false,
      refreshed: false,
      chamado: 1,
      ocultarBloqueados: false,
      liberaOpen: false,
      selected: Array(),
      openSelect: false,
      body: {
        filter: false,
        versoes: false,
        versoesEMS: false,
        filterBloqueados: false,
        aplicativo: false,
        atividades: [],
        personas: [],
        analistas: [],
        arquivos: []
      },
      totalRegistros: 0,
      mapOptions: {
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
      },
      msg: false,
      isMobile: false,
      mapping: false,
      loadinData: true,
      search: "",
      endereco: false,
      coords: false,
      activemap: false,
      errorSaved: false,
      empSaved: false,
      timeOut: false,
      clientesArr: [],
      pagination: { rowsPerPage: 100 },
      dropdown_icon: [
        { text: "list", callback: () => console.log("list") },
        { text: "favorite", callback: () => console.log("favorite") },
        { text: "delete", callback: () => console.log("delete") }
      ],
      headers: [
        {
          text: "Código",
          value: "CLICODIGO",
          width: "30px"
        },
        {
          text: "Nome",
          value: "CLINOME"
        },
        {
          text: "Nome Usual",
          value: "CLINOMEUSUAL"
        },
        {
          text: "CNPJ",
          value: "CLICNPJ"
        },
        {
          text: "IE",
          value: "CLIIE"
        },
        {
          text: "Atividade",
          value: "ATIVDESCRICAO"
        },
        {
          text: "Persona",
          value: "CLIPERSONA"
        },
        {
          text: "Analista",
          value: "USUNOME"
        }
      ],
      desserts: [],
      mensagem: "",
      snackbar: false,
      snackbarColor: "info"
    };
  },

  methods: {
    detalhesClientes(cliente) {
      var self = this;
      return ClientesService.getDetalhesClientes({
        CLICODIGO: cliente.CLICODIGO
      });
    },
    removeDuplicateObjects(array) {
      return [...new Set(array.map(s => JSON.stringify(s)))].map(s =>
        JSON.parse(s)
      );
    },
    bloqueiaLiberacao(cliente, ev) {
      this.LoginDialogTrigger = true;
    },
    paginate(operator) {
      if (operator === "+") this.$refs.clientesTable.computedPagination.page++;
      else if (this.$refs.clientesTable.computedPagination.page > 1)
        this.$refs.clientesTable.computedPagination.page--;
    },
    updatePagination() {
      /*if (
        document.body.scrollTop != 0 ||
        document.documentElement.scrollTop != 0
      ) {
        window.scrollBy(0, -50);
        this.timeOut = setTimeout(this.updatePagination(), 30);
      } else clearTimeout(this.timeOut);*/
    },
    destinoChamados(_CLICODIGO, _CLIDESTSUPORTE) {
      var self = this;
      var body = {
        CLICODIGO: _CLICODIGO,
        CLIDESTSUPORTE: _CLIDESTSUPORTE
      };

      ClientesService.changeDestinoChamados(body).then(r => {
        self.msg = r.Message;
      });
    },
    aplicativoChamados(_CLICODIGO, _CLIAPPSUPORTE) {
      var self = this;
      var body = {
        CLICODIGO: _CLICODIGO,
        CLIAPPSUPORTE: _CLIAPPSUPORTE
      };

      ClientesService.changeAplicativoChamados(body).then(r => {
        self.msg = r.Message;
      });
    },
    toogleBloqueados(ev) {
      var self = this;
      self.body.filterBloqueados = ev ? ev : false;
      self.body.filter = self.exibirInativos;
      self.findData({
        filterBloqueados: ev ? ev : false,
        filters: self.exibirInativos
      });
      if (ev) {
        self.clientesArr.forEach(el => {
          if (el.CLASSCLICODIGO > 2) {
            self.clientesArr.remove(el);
          }
        });
      } else {
        self.findData();
      }
    },
    liberarArquivos(selected) {
      this.liberaOpen = true;
      setTimeout(() => {
        this.liberaOpen = false;
      }, 10);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    addItemtoSelect(item) {
      var exist = false;
      this.selected.forEach(element => {
        if (item == element) {
          exist = true;
        }
      });
      exist ? this.selected.remove(item) : this.selected.push(item);
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.clientesArr.slice();
      this.selected.forEach(el => {
        if (el.BLOQUEADO) {
          this.selected.remove(el);
        }
      });
    },
    defaultLocation(item) {
      this.$getLocation({
        enableHighAccuracy: true
      }).then(coordinates => {
        item.LATITUDE = coordinates.lat;
        item.LONGITUDE = coordinates.lng;
      });
    },
    calcDiffDates(date) {
      var antes = moment(date).format();
      var depois = moment(new Date()).format();

      var time = moment.duration(moment(depois).diff(antes));

      var horas = time.asHours();

      if (horas < 24) {
        return "#a5d6a7";
      } else if (horas > 24 && horas < 72) {
        return "#ffcc80";
      } else if (horas > 72) {
        return "#ef9a9a";
      } else {
        return "#ef9a9a";
      }
    },
    openMaps(user) {
      var self = this;
      self.mapping = true;
      Geocoding.getApiData(user)
        .then(resp => {
          self.coords = resp.geometry.location;
          self.endereco = user.ENDCOMLPETE;
          self.activemap = true;

          self.mapping = false;
        })
        .catch(() => {
          self.mapping = false;
          self.msg = "O servidor não respondeu como esperado.";
        });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    mapclosed() {
      this.activemap = false;
      this.coords = false;
      this.endereco = false;
    },
    findData(data, eventTrig) {
      var self = this;

      var pArquivos = self.arquivos.map((e) => {
        return e.split(' (')[0];
      });      

      var body = {
        filter: data ? data.filter : false,
        versoes: self.versoes ? self.versoes : false,
        versoesEMS: self.versoesEMS ? self.versoesEMS : false,
        filterBloqueados: self.ocultarBloqueados ? self.ocultarBloqueados : false,
        aplicativo: self.aplicativo ? self.aplicativo : false,
        atividades: self.atividades,
        personas: self.personas,
        analistas: self.analistas,
        arquivos: pArquivos
      };
      self.body.versoes = self.versoes ? self.versoes : false;
      self.body.versoesEMS = self.versoesEMS ? self.versoesEMS : false;
      self.body.aplicativo = self.aplicativo ? self.aplicativo : false;
      self.body.atividades = self.atividades;
      self.body.personas = self.personas;
      self.body.analistas = self.analistas;
      self.body.arquivos = pArquivos;

      if (!eventTrig) self.$emit("filters", self.body);

      self.refreshed = false;

      self.loadinData = true;

      self.ocultarBloqueados = false;

      ClientesService.getClientes(body)
        .then(resp => {
          self.totalRegistros = resp.length;
          self.clientesArr = resp;
          self.loadinData = false;
        })
        .catch(() => {
          self.loadinData = false;
        })
        .finally(() => {
          self.refreshed = true;
        });
    },
    closeDialog(snackbar) {
      this.dialog = false;

      if (snackbar) {
        this.mensagem = snackbar.mensagem;
        this.snackbar = snackbar.snackbar;
        this.snackbarColor = snackbar.snackbarColor;
      }
    },
    copyExcel() {
      var self = this;

      var aux = self.headers.map((e) => {
        return e.text;
      }).join('\t') + '\n';

      aux += self.clientesArr.map((e) => {
        return self.headers.map((ex) => {
          return e[ex.value];
        }).join('\t');
      }).join('\n');

      navigator.clipboard.writeText(aux);
    },
    copyJSON() {
      var self = this;
      navigator.clipboard.writeText(JSON.stringify(self.clientesArr));
    }
  },
  created() {
    var self = this;
    self.findData();
  },
  mounted() {
    var self = this;
  }
};
</script>
<style scoped>
.bloqueiobox {
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #999;
}
.controlstop {
  display: flex;
  justify-content: flex-end;
}
#tabelaclientes {
  z-index: 100 !important;
}
.v-datatable__actions__range-controls {
  color: #000;
}
.refreshicon {
  margin: 10px;
}
.subtitle-2 {
  max-width: 270px;
  min-height: 30px;
}
.overlayy {
  z-index: 10;
  background: rgba(0, 0, 0, 0.39);
  position: absolute;
  width: 100%;
  height: 99%;
  top: 0;
  border-radius: 5px;
  left: 0;
}
li {
  min-height: 58px;
}
.iconedit {
  font-size: 15px !important;
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0;
  cursor: pointer;
}
.descarrude:hover .iconedit {
  opacity: 1;
}
.iconedit:hover {
  font-size: 16px !important;
  position: absolute;
  color: #000 !important;
  top: 5px;
}
.mapcontent {
  flex-flow: column;
  width: 32%;
  justify-content: center;
  align-items: center;
  display: flex;
}

span,
div,
table,
td,
tr,
th {
  transition: all 0.3s ease !important;
}
#selectbox {
  margin-bottom: 1em;
  padding: 0.25em;
  border: 0;
  border-bottom: 2px solid #333;
  font-weight: bold;
  border-radius: 0;
}
.optionsle {
  background: #333;
  border: 2px solid #333;
  margin: 5px;
  padding: 5px;
  color: #fff;
}
.containertable {
  margin: 0px 45px 45px 45px;
  display: flex;
  background: #fff;
  flex-flow: column;
}
.containertable table {
  width: 100%;
}

.containertable td,
th {
  border: 1px solid transparent !important;
  border-color: transparent !important;
  text-align: left;
  padding: 8px;
}

.containertable tr:nth-child(even) {
  background-color: #dddddd;
}
</style>
<style>
#tabelaclientes .v-datatable__actions__select {
  opacity: 0;
  display: none !important;
}
td,
th {
  border-color: transparent !important;
}
</style>
